module.exports = __webpack_public_path__ + "static/img/Education_new.bf2dbbab.jpg";